import React from 'react';
import './HomeBylawsBanner.css';

const HomeBylawsBanner = ({ onNavigate }) => {
  return (
    <section className="home-bylaws-banner">
      <div className="home-bylaws-banner-inner">
        <div className="home-bylaws-banner-text">
          <span className="home-bylaws-banner-label">Resmî tüzük</span>
          <h2 className="home-bylaws-banner-title">Türkiye Kalite Mühendisleri Derneği Tüzüğü</h2>
          <p className="home-bylaws-banner-desc">
            TKMB – Türkiye Kalite Mühendisleri Birliği tüzüğünü inceleyebilir, derneğin amaçları, üyelik türleri ve organları hakkında bilgi edinebilirsiniz.
          </p>
        </div>
        <div className="home-bylaws-banner-action">
          <button
            type="button"
            className="home-bylaws-banner-btn"
            onClick={() => onNavigate && onNavigate('bylaws')}
          >
            Tüzüğü Görüntüle
          </button>
        </div>
      </div>
    </section>
  );
};

export default HomeBylawsBanner;
